module.exports = __webpack_public_path__ + "static/media/professional-teaching-ad3.79cd2a0b.png";